{/* Auto-generated icon - do not edit */}
import React from 'react'

interface NightIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const NightIcon = React.forwardRef<SVGSVGElement, NightIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 155 146"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M121.957 103.163C125.881 102.928 129.837 102.923 133.72 102.388C136.915 101.948 140.025 100.889 143.171 100.09C144.691 99.7039 146.182 99.1546 147.722 98.9084C149.978 98.5468 152.001 99.1598 153.325 101.147C154.572 103.018 154.264 104.954 153.333 106.905C148.513 117.012 140.849 124.655 131.986 131.141C121.135 139.082 108.699 143.113 95.4809 144.727C83.273 146.22 71.0442 146.272 58.9531 143.581C41.4413 139.684 26.3475 131.645 15.1444 117.275C4.13504 103.155 -0.0989723 87.0189 1.45589 69.2977C2.82654 52.995 8.52934 37.3547 17.9739 23.9961C23.4215 16.2146 29.9055 9.38657 38.073 4.33996C41.1493 2.43658 44.3527 0.861628 48.0742 0.664725C51.9288 0.463885 53.2713 2.38262 51.5635 5.85005C49.1278 10.7962 47.0392 15.8499 46.0186 21.3061C44.6114 28.8264 45.0945 36.2542 46.782 43.6767C50.4181 59.6657 57.3876 73.8803 68.9806 85.6373C78.1431 95.0885 90.3707 100.969 103.474 102.226C109.604 102.883 115.778 103.131 121.932 103.566C121.939 103.437 121.948 103.299 121.957 103.163ZM135.166 114.522L134.675 113.716C132.895 113.803 131.106 113.809 129.336 113.989C121.505 114.712 113.623 114.668 105.801 113.858C85.496 111.959 68.9865 103.067 56.2719 87.1816C46.7389 75.1897 40.233 61.0786 37.3039 46.0418C35.0461 34.9057 35.1379 23.989 39.2774 13.2736C39.3607 13.0583 39.1666 12.7358 39.0373 12.1897C37.6078 13.4486 36.2878 14.4907 35.1064 15.6688C18.843 31.9145 10.5927 51.6164 10.1962 74.5235C9.93043 89.8451 14.8215 103.357 25.3577 114.71C34.7177 124.796 46.4814 130.463 59.6646 133.425C72.5478 136.32 85.5466 136.06 98.4981 133.917C108.934 132.191 118.632 128.475 127.031 121.894C129.905 119.647 132.464 116.992 135.166 114.522Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="153.583" height="145.707" fill={color} transform="translate(0.579834 0.0625)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

NightIcon.displayName = 'NightIcon'
